import { Injectable } from '@angular/core';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { UserRoleViewModel } from '../business-entities/user-role-view-model';
import { RoleDetailsViewModel } from './../business-entities/role-details-view-model';
import { RolesRightsDataService } from './../data-services/roles-rights-data.service';
import { GenericResponse } from '../../../../Autofacets-Core/src/app/business-entities/generic-response.class';

@Injectable({ providedIn: 'root' })
export class RolesRightsService {

    selectedRole: UserRoleViewModel;

    constructor(
        private rolesRightsDataService: RolesRightsDataService,
        private secureStorage: SecureStorage
    ) {}

    async getRoles(): Promise<UserRoleViewModel[]> {
        let userRoles: UserRoleViewModel[] = []
        await this.rolesRightsDataService.getRoles().then((result) => {
            userRoles = result.responseObject.result as UserRoleViewModel[];
        });
        return userRoles;
    }

    async getRoleDetails(id: number): Promise<RoleDetailsViewModel> {
        let roleDetails: RoleDetailsViewModel;
        await this.rolesRightsDataService.getRoleDetails(id).then((result) => {
            roleDetails = result.responseObject.result as RoleDetailsViewModel;
        });
        return roleDetails;
    }

    saveRoleRights(roleDetails: RoleDetailsViewModel): Promise<any> {
        return this.rolesRightsDataService.saveRoleRights(roleDetails);
    }
    getFeatures(): Promise<any>{
        return this.rolesRightsDataService.getFeatures();
    }
    getFeatureByDealerId(featureCode:string,dealerId:string,brandCode:string): Promise<any>{
        return this.rolesRightsDataService.getFeatureByDealerId(featureCode,dealerId,brandCode);
    }
    updateFeature(model:any): Promise<any>{
        return this.rolesRightsDataService.updateFeature(model);
    }
    getRoleList(): Promise<any>{
        return this.rolesRightsDataService.getRoleList();
    }
    getEmployeeList(employeeListRequestModel:any){
        return this.rolesRightsDataService.getEmployeeList(employeeListRequestModel);
    }
    AddRole(RoleModel: any): Promise<GenericResponse<any>> {
        return this.rolesRightsDataService.AddRole(RoleModel);
    }
    GetApplicationList(): Promise<any>{
        return this.rolesRightsDataService.GetApplicationList();
    }

    updateStampInOutFeature(role:any):Promise<any>{
        return this.rolesRightsDataService.updateStampInOutFeature(role);
    }
}